export const LAST_ACTIVE_RETAILER = 'LAST_ACTIVE_RETAILER';
